var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20,14a30.433,30.433,0,0,0-1-8.627V3.5a.5.5,0,0,0-.5-.5H5.5a.5.5,0,0,0-.5.5V5.424A31.063,31.063,0,0,0,4.017,14c0,3.917.489,4.754.983,4.994V20.5a.5.5,0,0,0,.5.5h13a.5.5,0,0,0,.5-.5V19C19.5,18.77,20,17.959,20,14ZM6,4H18V5H6ZM18,20H6V19H18Zm.606-1.992a.484.484,0,0,0-.053,0A.452.452,0,0,0,18.5,18H5.5a.572.572,0,0,0-.057.011c-.01,0-.021,0-.031,0-.132-.279-.395-1.19-.395-4.011a32.339,32.339,0,0,1,.861-8H18.139A32.392,32.392,0,0,1,19,14C19,16.814,18.738,17.727,18.606,18.008Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.011,10.516A4.215,4.215,0,0,0,8,14.5a2.012,2.012,0,0,0,.6,1.479,4.7,4.7,0,0,0,3.38.976H12l.026-.5.032.5h.018a4.674,4.674,0,0,0,3.35-.976,2.015,2.015,0,0,0,.6-1.479A4.215,4.215,0,0,0,12.011,10.516Zm2.706,4.755c-.256.256-.939.684-2.643.684h-.126c-1.7,0-2.387-.428-2.643-.684A1.034,1.034,0,0,1,9,14.5a3.258,3.258,0,0,1,3.011-2.984A3.257,3.257,0,0,1,15.022,14.5,1.031,1.031,0,0,1,14.717,15.271Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5,8A1.5,1.5,0,1,0,17,9.5,1.5,1.5,0,0,0,15.5,8Zm0,2a.5.5,0,1,1,.5-.5A.5.5,0,0,1,15.5,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,9.5A1.5,1.5,0,1,0,8.5,11,1.5,1.5,0,0,0,10,9.5Zm-2,0a.5.5,0,1,1,.5.5A.5.5,0,0,1,8,9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,10a1.5,1.5,0,1,0-1.5-1.5A1.5,1.5,0,0,0,12,10Zm0-2a.5.5,0,1,1-.5.5A.5.5,0,0,1,12,8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPet);
export default __webpack_public_path__ + "static/media/pet.50708d0ec77dd5bbd8c5b32bccc446c3.svg";
export { ForwardRef as ReactComponent };